import { Typography as TypographyAntd } from 'antd';
import styled from 'styled-components';

export const Label = styled(TypographyAntd.Text)`
  font-size: 16px;
  font-weight: bold;
`;
